import {
  Button,
  Cascader,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Popover,
  notification,
  Radio,
  Row,
  Select,
  Space,
  TreeSelect,
  TreeSelectProps,
} from 'antd'
import React, { useContext, useEffect, useImperativeHandle, useRef, useState, forwardRef } from 'react'
import { SearchOutlined, CaretDownFilled } from '@ant-design/icons'
import { useDebouncedCancel } from '../../utils/useDebouncedCancel'
import { useCascaderDropdownRender } from '../storesearch/query'
import { useDispatch, useSelector } from 'react-redux'
import { pageSupplier, selectSupplierdata } from '../wms/supplierSlice'
import { commodityPageParams } from '../../services/commodity'
import { getOtcCategoryName, OtcCategories } from '../../models/Otccategory'
import { savePriceTagCatalogAsync, setCurrent } from './commoditySlice'
import styles from './Commodity.module.css'
import {
  getMaterialsCategoryName,
  getMaterialsName,
  Materiales,
  MaterialsCategories,
} from '../../models/commodity'
import {
  selectInsuranceArray,
  selectTenantName,
} from '../../app/applicationSlice'
import { DefaultOptionType } from 'antd/lib/select'
import {
  getCodeCompletions,
  getCommonCodeCompletionsAsync,
  getRecipeItemCompletions,
  ItemCompletionType,
} from '../completion/completionSlice'
import { CommonCodeCategory } from '../../models/commoncode'
import { RootDispatch } from '../../app/store'
import { unwrapResult } from '@reduxjs/toolkit'
import { FilterIconOutlined } from '../../compnents/icons/Icons'
import { ThemeContext } from '../../theme/ThemeContext'
import { DateTimeFormat, DateTimeFormatSimpleOnlyOne } from '../../models/datetime'
import moment from 'moment'
import { FilterColumn } from '../../compnents/filterForm/filterForm'
import { BillingCategoryName, InvoiceBillingCategories } from '../../models/billingCategory'
import { RecipeItemInput } from '../treatment/editor/components/RecipeItemInput'

const { Option } = Select

const { TreeNode } = TreeSelect

const { RangePicker } = DatePicker

// const useCascaderDropdownRender = (
//   treeData: any[],
//   getValue: () => any[][],
//   setValue: (v: any[][]) => void,
//   onChange: () => void,
// ) => {
//   return React.useCallback((menus: React.ReactNode) => {
//     const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
//       const target = e.target as HTMLElement
//       // 只处理一级菜单列（第一列）中的菜单项
//       const menuItem = target.closest('.ant-cascader-menu-item') as HTMLElement | null
//       if (!menuItem) return
//       const menu = menuItem.closest('.ant-cascader-menu') as HTMLElement | null
//       if (!menu) return
//       // 判断是否是第一列（一级菜单）
//       const menus = menu.parentElement?.querySelectorAll('.ant-cascader-menu')
//       const menuIndex = menus ? Array.from(menus).indexOf(menu) : -1
//       if (menuIndex !== 0) return
//       // 点击的已经是 checkbox 本身，不重复触发
//       if (target.closest('.ant-checkbox-wrapper')) return
//
//       // 从文本内容找到对应的一级节点
//       const labelEl = menuItem.querySelector('.ant-cascader-menu-item-content')
//       const labelText = labelEl?.textContent?.trim()
//       const topNode = treeData.find((v) => v.label === labelText)
//       if (!topNode) return
//
//       const currentValue: any[][] = getValue() || []
//       const topVal = topNode.value
//
//       // 判断当前一级是否已全选（一级本身 + 所有子项都在）
//       const hasTop = currentValue.some((p) => p.length === 1 && p[0] === topVal)
//       const children: any[] = topNode.children || []
//       const allChildPaths = children.map((c: any) => [topVal, c.value])
//       const allChildSelected = allChildPaths.every((cp) =>
//         currentValue.some((p) => p[0] === cp[0] && p[1] === cp[1])
//       )
//       const isFullySelected = hasTop && (children.length === 0 || allChildSelected)
//
//       let newValue: any[][]
//       if (isFullySelected) {
//         // 已全选 → 取消该一级及其所有子项
//         newValue = currentValue.filter((p) => p[0] !== topVal)
//       } else {
//         // 未全选 → 选中一级本身 + 所有子项
//         const withoutTop = currentValue.filter((p) => p[0] !== topVal)
//         newValue = [...withoutTop, [topVal], ...allChildPaths]
//       }
//
//       setValue(newValue)
//       onChange()
//     }
//     return <div onClick={handleClick}>{menus}</div>
//   }, [treeData])
// }

const normalizeMaterialsCategory = (value: any) => {
  if (!value) {
    return []
  }
  if (Array.isArray(value) && value.length === 0) {
    return []
  }
  if (Array.isArray(value) && Array.isArray(value[0])) {
    return value
  }
  if (Array.isArray(value)) {
    return [value]
  }
  return []
}

const getMaterialsCategoryParams = (value: any) => {
  const list = normalizeMaterialsCategory(value)

  // length === 1：仅选中大类节点 → 视为该大类全选（仅传 materialsCategory）
  const fullySelectedTopList = Array.from(
    new Set(
      list
        .filter((item: any) => Array.isArray(item) && item.length === 1)
        .map((item: any) => item?.[0])
        .filter((v: any) => v !== undefined && v !== null && v !== '')
    )
  )

  // length >= 2：选中了具体子类 → 进 category
  const fullySelectedSet = new Set(fullySelectedTopList.map((v: any) => String(v)))
  const childCategoryList = Array.from(
    new Set(
      list
        .filter((item: any) => Array.isArray(item) && item.length >= 2)
        // 同一大类已整类选中，子类条件会被 OR 覆盖，无需重复传
        .filter((item: any) => !fullySelectedSet.has(String(item?.[0])))
        .map((item: any) => item?.[1])
        .filter((v: any) => v !== undefined && v !== null && v !== '')
    )
  )

  const materialsCategory = fullySelectedTopList.join(',')
  const category = childCategoryList.join(',')

  return {
    materialsCategoryList: undefined,
    materialsCategory: materialsCategory || undefined,
    category: category || undefined,
  }
}

const getMaterialsCategoryInfo = (materialsCategoryList: any) => {
  const materialsCategory = materialsCategoryList?.filter((v: any) => v?.length == 1)
  const category = materialsCategoryList?.filter((v: any) => v?.length != 1).map((item: any) => item?.[1])
  console.log("materialsCategory123", materialsCategory?.length ? materialsCategory?.join(',') : '')
  console.log("category123", category?.length ? category?.join(',') : '')
  return {
    materialsCategory: materialsCategory?.length ? materialsCategory?.join(',') : '',
    category: category?.length ? category?.join(',') : '',
    materialsCategoryList: materialsCategoryList,
  }
}

export const Commodityquery = (props: {
  materialsCategory?: any
  loading?: any
  filterColumn?: any[]
  filterSelectList?: any[]
  submitPageList?: (v: any) => void
  onValueChange: (queries: commodityPageParams) => void
}) => {
  const [form] = Form.useForm()

  const [popoverForm] = Form.useForm()

  const [open, setOpen] = useState(false)

  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const tenantName = useSelector(selectTenantName)

  const data = useSelector(selectSupplierdata)

  const insuranceArray = useSelector(selectInsuranceArray)

  const [treeData, setTreeData] = useState<any>([])

  const getYPFL = () => {
    const data = Materiales.map((v) => {
      return {
        id: v,
        value: v.toString(),
        label: getMaterialsName(v),
        children: [],
      }
    })

    dispatch(
      getCommonCodeCompletionsAsync({
        category: CommonCodeCategory.Durg,
        keyword: '',
      })
    )
      .then(unwrapResult)
      .then((res) => {
        const tree = data.map((v) => {
          if (v.id == 0) {
            return {
              ...v,
              children: res.records.map((el: any) => ({
                value: el.codeName,
                label: el.codeName,
              })),
            }
          } else if (v.id == 1) {
            return {
              ...v,
              children: [
                { value: '材料', label: '材料' },
                { value: '器械', label: '器械' },
                { value: '消耗品', label: '消耗品' },
                { value: '其他', label: '其他' },
              ],
            }
          } else if (v.id == 2) {
            return {
              ...v,
              children: [
                { value: '第一类医疗器械', label: '第一类医疗器械' },
                { value: '第二类医疗器械', label: '第二类医疗器械' },
                { value: '第三类医疗器械', label: '第三类医疗器械' },
              ],
            }
          } else if (v.id == 4) {
            return {
              ...v,
              children: [
                { value: '食品', label: '食品' },
                { value: '化妆品', label: '化妆品' },
                { value: '保健品', label: '保健品' },
                { value: '卫生消毒用品', label: '卫生消毒用品' },
                { value: '初级农产品', label: '初级农产品' },
                { value: '其他产品', label: '其他产品' },
              ],
            }
          } else {
            return v
          }
        })

        setTreeData(tree)
      })
  }

  useEffect(() => {
    if (insuranceArray.length) {
      form.setFieldsValue({
        insuranceCode: insuranceArray[0].insuranceCode,
      })
    }
  }, [insuranceArray])

  const dataParams = JSON.parse(sessionStorage.getItem('/commodity') || '{}')

  useEffect(() => {
    getYPFL()
    dispatch(pageSupplier({ supplierCategory: 1, size: 20 }))
    if (Object.keys(dataParams).length) {
      form.setFieldsValue({
        ...dataParams,
        materialsCategory: normalizeMaterialsCategory(dataParams?.materialsCategoryList),
      })
      popoverForm.setFieldsValue({
        chrgitmLvs: dataParams?.chrgitmLvs ? dataParams?.chrgitmLvs?.split(',') : [],
        psychotropic1Tag: dataParams?.psychotropic1Tag ? true : false,
        psychotropic2Tag: dataParams?.psychotropic2Tag ? true : false,
        anaesthesiaTag: dataParams?.anaesthesiaTag ? true : false,
        narcoticTag: dataParams?.narcoticTag ? true : false,
        ephedrineTag: dataParams?.ephedrineTag ? true : false,
        stimulantTag: dataParams?.stimulantTag ? true : false,
        natNegoDrugFlag: dataParams?.natNegoDrugFlag ? true : false,
        provinceTendFlag: dataParams?.provinceTendFlag ? true : false,
        antibioticTag: dataParams?.antibioticTag ? true : false,
        basicMedicineTag: dataParams?.basicMedicineTag ? true : false,
        showFlag: dataParams?.showFlag === 1 ? ['0', '1'] : dataParams?.showFlag === 0 ? ['0'] : dataParams?.showFlag === 2 ? ['1'] : [],
        isLimitPrice: dataParams?.isLimitPrice == 1 ? ['1'] : dataParams?.isLimitPrice === 0 ? ['0'] : dataParams?.isLimitPrice === 2 ? ['0', '1'] : [],
        gtPrice: dataParams?.gtPrice === 1 ? ['1'] : [],
        ltPrice: dataParams?.ltPrice === 1 ? ['1'] : [],
        eqPrice: dataParams?.eqPrice === 1 ? ['1'] : [],
        ltCostPrice: dataParams?.ltCostPrice === 1 ? ['1'] : [],
        gtCostPrice: dataParams?.gtCostPrice === 1 ? ['1'] : [],
        eqCostPrice: dataParams?.eqCostPrice === 1 ? ['1'] : [],
        complexPrice: dataParams?.complexPrice === 1 ? ['1'] : [],
        lastUpdateTime: dataParams?.lastUpdateTimeStart
          ? [moment(dataParams?.lastUpdateTimeStart), moment(dataParams?.lastUpdateTimeEnd)]
          : [],
      })
    }
    form.submit()
  }, [])

  const refresh = () => {
    const materialsCategoryList = form.getFieldsValue()?.materialsCategory
    const showFlagValue: any = popoverForm.getFieldsValue()?.showFlag
    const isLimitPriceValue: any = popoverForm.getFieldsValue()?.isLimitPrice
    const gtPrice: any = popoverForm.getFieldsValue()?.gtPrice
    const ltPrice: any = popoverForm.getFieldsValue()?.ltPrice
    const eqPrice: any = popoverForm.getFieldsValue()?.eqPrice
    const ltCostPrice: any = popoverForm.getFieldsValue()?.ltCostPrice
    const gtCostPrice: any = popoverForm.getFieldsValue()?.gtCostPrice
    const eqCostPrice: any = popoverForm.getFieldsValue()?.eqCostPrice
    const complexPrice: any = popoverForm.getFieldsValue()?.complexPrice

    const overLimitPrice: any = popoverForm.getFieldsValue()?.overLimitPrice
    const lastUpdateTime: any = popoverForm.getFieldsValue()?.lastUpdateTime
    const lastUpdateTimeStart = lastUpdateTime?.[0]
      ? lastUpdateTime?.[0]?.format(DateTimeFormatSimpleOnlyOne)
      : undefined
    const lastUpdateTimeEnd = lastUpdateTime?.[1]
      ? lastUpdateTime?.[1]?.format(DateTimeFormatSimpleOnlyOne)
      : undefined
    const data = {
      ...dataParams,
      ...form.getFieldsValue(),
      // ...getMaterialsCategoryParams(category),
      current: 1,
      ...popoverForm.getFieldsValue(),
      lastUpdateTimeStart,
      lastUpdateTimeEnd,
      lastUpdateTime: undefined,
      ...getMaterialsCategoryInfo(materialsCategoryList),
      chrgitmLvs: popoverForm.getFieldsValue()?.chrgitmLvs
        ? popoverForm.getFieldsValue()?.chrgitmLvs?.join(',')
        : '',
      psychotropic1Tag: popoverForm.getFieldsValue()?.psychotropic1Tag
        ? Number(popoverForm.getFieldsValue()?.psychotropic1Tag)
        : undefined,
      psychotropic2Tag: popoverForm.getFieldsValue()?.psychotropic2Tag
        ? Number(popoverForm.getFieldsValue()?.psychotropic2Tag)
        : undefined,
      anaesthesiaTag: popoverForm.getFieldsValue()?.anaesthesiaTag
        ? Number(popoverForm.getFieldsValue()?.anaesthesiaTag)
        : undefined,
      narcoticTag: popoverForm.getFieldsValue()?.narcoticTag
        ? Number(popoverForm.getFieldsValue()?.narcoticTag)
        : undefined,
      natNegoDrugFlag: popoverForm.getFieldsValue()?.natNegoDrugFlag
        ? Number(popoverForm.getFieldsValue()?.natNegoDrugFlag)
        : undefined,
      provinceTendFlag: popoverForm.getFieldsValue()?.provinceTendFlag
        ? Number(popoverForm.getFieldsValue()?.provinceTendFlag)
        : undefined,
      antibioticTag: popoverForm.getFieldsValue()?.antibioticTag
        ? Number(popoverForm.getFieldsValue()?.antibioticTag)
        : undefined,
      basicMedicineTag: popoverForm.getFieldsValue()?.basicMedicineTag
        ? Number(popoverForm.getFieldsValue()?.basicMedicineTag)
        : undefined,
      ephedrineTag: popoverForm.getFieldsValue()?.ephedrineTag
        ? Number(popoverForm.getFieldsValue()?.ephedrineTag)
        : undefined,
      stimulantTag: popoverForm.getFieldsValue()?.stimulantTag
        ? Number(popoverForm.getFieldsValue()?.stimulantTag)
        : undefined,

      showFlag:
        showFlagValue?.join(',') == '0,1' || showFlagValue?.join(',') == '1,0'
          ? 1
          : showFlagValue?.join(',') == '0'
            ? 0
            : showFlagValue?.join(',') == '1'
              ? 2
              : '',
      isLimitPrice:
        isLimitPriceValue?.join(',') == '0,1' || isLimitPriceValue?.join(',') == '1,0'
          ? 2
          : isLimitPriceValue?.join(',') == '0'
            ? 0
            : isLimitPriceValue?.join(',') == '1'
              ? 1
              : '',
      gtPrice: gtPrice?.[0] == 1 ? 1 : 0,
      ltPrice: ltPrice?.[0] == 1 ? 1 : 0,
      eqPrice: eqPrice?.[0] == 1 ? 1 : 0,
      ltCostPrice: ltCostPrice?.[0] == 1 ? 1 : 0,
      gtCostPrice: gtCostPrice?.[0] == 1 ? 1 : 0,
      eqCostPrice: eqCostPrice?.[0] == 1 ? 1 : 0,
      complexPrice: complexPrice?.[0] == 1 ? 1 : 0,
    }
    props.onValueChange(data)
  }

  const debouncedRefresh = useDebouncedCancel(300)

  const debouncedSupplierSearch = useDebouncedCancel(300)

  const dropdownRender = useCascaderDropdownRender(
    treeData,
    () => normalizeMaterialsCategory(form.getFieldValue('materialsCategory')),
    (v) => form.setFieldsValue({ materialsCategory: v }),
    refresh,
  )

  return (
    <Form
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(values) => {
        const materialsCategoryList = values?.materialsCategory
        props.onValueChange({
          ...dataParams,
          ...values,
          ...getMaterialsCategoryInfo(materialsCategoryList),
          current: dataParams.current || 1,
        })
      }}
      initialValues={{
        state: 1,
      }}
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          <Form.Item name='allStr' noStyle>
            <Input
              size='middle'
              placeholder='搜索关键词'
              allowClear
              prefix={<SearchOutlined />}
              onChange={() => debouncedRefresh(() => refresh())}
            />
          </Form.Item>
          {/* <Col span={3}>
          <Form.Item name='approveFlg'>
            <Select
              placeholder='医保状态'
              allowClear
              dropdownClassName={styles.select}
              suffixIcon={<CaretDownFilled />}
              onChange={refresh}
            >
              <Option value='0'>未上传</Option>
              <Option value='-1'>审批未通过 </Option>
              <Option value='1'>审批已通过</Option>
              <Option value='2'>已上传待审批</Option>
            </Select>
          </Form.Item>
        </Col> */}
          <Form.Item name='materialsCategory' noStyle>
            <Cascader
              className={styles.materialsCategoryCascader}
              options={treeData}
              onChange={(v: any) => {
                refresh()
              }}
              multiple
              maxTagTextLength={12}
              changeOnSelect
              placeholder='商品类别'
              expandTrigger="hover"
              dropdownRender={dropdownRender}
            />
            {/* <TreeSelect
              placeholder="商品类别"
              allowClear
              onChange={refresh}
            >
              {
                treeData.length && treeData.map((v: any, index: number) => (
                  <TreeNode value={v.id} title={v.title} key={v.id}>
                    {
                      !!v.children.length && v.children.map((el: any) => (
                        <TreeNode value={el.id} title={el.title} key={el.id} />
                      ))
                    }
                  </TreeNode>))
              }
            </TreeSelect> */}
          </Form.Item>
          {/* <Form.Item name='allMaterials' noStyle>
            <Select
              placeholder='药品范围'
              allowClear
              dropdownClassName={styles.select}
              // suffixIcon={<CaretDownFilled />}
              onChange={refresh}
            >
              <Option value='0'>兴奋剂</Option>
              <Option value='1'>麻黄碱</Option>
              <Option value='2'>抗生素</Option>
              <Option value='3'>基药</Option>
            </Select>
          </Form.Item> */}
          <Form.Item name='tenantSupplierId' noStyle>
            <Select
              placeholder='生产厂家'
              allowClear
              showSearch
              onChange={refresh}
              optionFilterProp='children'
              // suffixIcon={<CaretDownFilled />}
              dropdownClassName={styles.select}
              onSearch={(v: any) => {
                debouncedSupplierSearch((cancelToken) => {
                  dispatch(
                    pageSupplier({ name: v, supplierCategory: 1, size: 20 }, cancelToken)
                  )
                })
              }}
            >
              {data.map((v: any, i) => {
                return (
                  <Option value={v.id} key={v.id}>
                    {v.companyName}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='state' noStyle>
            <Select
              placeholder='状态'
              // defaultValue={1}
              onChange={refresh}
            // suffixIcon={<CaretDownFilled />}
            >
              <Option value={0}>注销</Option>
              <Option value={1}>启用</Option>
            </Select>
          </Form.Item>
          <Form.Item name='otc' noStyle>
            <Select
              placeholder='OTC'
              allowClear
              onChange={refresh}
            // suffixIcon={<CaretDownFilled />}
            >
              {OtcCategories.map((v) => {
                return (
                  <Option value={v} key={v}>
                    {getOtcCategoryName(v)}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          {insuranceArray.length !== 0 && (
            <>
              <Form.Item name='insuranceCode' noStyle>
                <Select
                  placeholder='医保险种'
                  // suffixIcon={<CaretDownFilled />}
                  // value={insuranceArray[0]}
                  onChange={refresh}
                >
                  {insuranceArray.map((v) => {
                    return (
                      <Option value={v.insuranceCode} key={v.id}>
                        {v.insuranceName}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
              {tenantName?.indexOf('余姚健齿口腔诊所有限公司') < 0 &&
                tenantName?.indexOf('余姚康民内科诊所') < 0 &&
                tenantName?.indexOf('宁波鄞州青木堂中医诊所') < 0 &&
                tenantName?.indexOf('宁波鄞州德益内科诊所有限公司') < 0 &&
                tenantName?.indexOf('宁波鄞州毅康内科诊所有限公司') < 0 && (
                  <Form.Item name='isMapping' noStyle>
                    <Select
                      placeholder='匹配状态'
                      allowClear
                      onChange={refresh}
                    // style={{ width: '100px' }}
                    // suffixIcon={<CaretDownFilled />}
                    >
                      <Option value='0'>未匹配</Option>
                      <Option value='1'>未上传</Option>
                      <Option value='2'>已上传</Option>
                    </Select>
                  </Form.Item>
                )}
            </>
          )}
          <Popover
            visible={open}
            overlayClassName={styles.formQueryPopover}
            content={
              <>
                <Form
                  form={popoverForm}
                  onFinish={(val) => {
                    refresh()
                    setOpen(false)
                  }}
                >
                  <Row>
                    <Col
                      className={styles.formQueryLabel}
                    >
                      等级：
                    </Col>
                    <Col>
                      <Form.Item label='' name='chrgitmLvs'>
                        <Checkbox.Group>
                          <Checkbox value={'01'} style={{ width: '112px' }}>甲</Checkbox>
                          <Checkbox value={'02'} style={{ width: '112px' }}>乙</Checkbox>
                          <Checkbox value={'03'}>丙</Checkbox>
                        </Checkbox.Group>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row className={styles.checkboxRow}>
                    <Col
                      className={styles.formQueryLabel}
                    >
                      药品范围：
                    </Col>
                    {/* 新版目录 增加 精一、精二、基药、兴奋 ，毒麻拆分为 毒物、麻醉、*/}
                    <div style={{ width: '120px' }}>
                      <Form.Item
                        label=''
                        name='psychotropic1Tag'
                        valuePropName='checked'
                      >
                        <Checkbox>精一</Checkbox>
                      </Form.Item>
                    </div>
                    <div style={{ width: '120px' }}>
                      <Form.Item
                        label=''
                        name='psychotropic2Tag'
                        valuePropName='checked'
                      >
                        <Checkbox>精二</Checkbox>
                      </Form.Item>
                    </div>
                    <div style={{ width: '120px' }}>
                      <Form.Item
                        label=''
                        name='anaesthesiaTag'
                        valuePropName='checked'
                      >
                        <Checkbox>毒性</Checkbox>
                      </Form.Item>
                    </div>
                    <div style={{ width: '70px' }}>
                      <Form.Item
                        label=''
                        name='narcoticTag'
                        valuePropName='checked'
                      >
                        <Checkbox>麻醉</Checkbox>
                      </Form.Item>
                    </div>
                  </Row>
                  <Row>
                    <Col
                      className={styles.formQueryLabel}
                    >
                    </Col>
                    <div style={{ width: '120px' }}>
                      <Form.Item
                        label=''
                        name='stimulantTag'
                        valuePropName='checked'
                      >
                        <Checkbox>兴奋剂</Checkbox>
                      </Form.Item>
                    </div>
                    <div style={{ width: '120px' }}>
                      <Form.Item
                        label=''
                        name='ephedrineTag'
                        valuePropName='checked'
                      >
                        <Checkbox>麻黄碱</Checkbox>
                      </Form.Item>
                    </div>
                    <div style={{ width: '120px' }}>
                      <Form.Item
                        label=''
                        name='antibioticTag'
                        valuePropName='checked'
                      >
                        <Checkbox>抗生素</Checkbox>
                      </Form.Item>
                    </div>
                    <div style={{ width: '70px' }}>
                      <Form.Item
                        label=''
                        name='basicMedicineTag'
                        valuePropName='checked'
                      >
                        <Checkbox>基药</Checkbox>
                      </Form.Item>
                    </div>
                  </Row>
                  <Row>
                    <Col
                      className={styles.formQueryLabel}
                    >
                    </Col>
                    <div style={{ width: '120px' }}>
                      <Form.Item
                        label=''
                        name='natNegoDrugFlag'
                        valuePropName='checked'
                      >
                        <Checkbox>国谈药</Checkbox>
                      </Form.Item>
                    </div>
                    <div style={{ width: '120px' }}>
                      <Form.Item
                        label=''
                        name='provinceTendFlag'
                        valuePropName='checked'
                      >
                        <Checkbox>省招药</Checkbox>
                      </Form.Item>
                    </div>
                  </Row>
                  <Row>
                    <Col
                      className={styles.formQueryLabel}
                    >
                      库存：
                    </Col>
                    <Col>
                      <Form.Item label='' name='showFlag'>
                        <Checkbox.Group>
                          <Checkbox value={'0'} style={{ width: '112px' }}> 有库存</Checkbox>
                          <Checkbox value={'1'}>零库存</Checkbox>
                        </Checkbox.Group>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={styles.formQueryLabel}
                    >
                      零售价：
                    </Col>
                    <Form.Item label='' name='gtPrice'>
                      <Checkbox.Group style={{ width: '120px' }}>
                        <Checkbox value={'1'}>超医保限价</Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                    <Form.Item label='' name='ltPrice'>
                      <Checkbox.Group style={{ width: '120px' }}>
                        <Checkbox value={'1'}>低于医保限价</Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                    <Form.Item label='' name='eqPrice'>
                      <Checkbox.Group style={{ width: '120px' }}>
                        <Checkbox value={'1'}>等于医保限价</Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                  </Row>
                  <Row>
                    <Col
                      className={styles.formQueryLabel}
                    >
                    </Col>
                    <Form.Item label='' name='ltCostPrice'>
                      <Checkbox.Group style={{ width: '120px' }}>
                        <Checkbox value={'1'}>低于进价</Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                    <Form.Item label='' name='gtCostPrice'>
                      <Checkbox.Group style={{ width: '120px' }}>
                        <Checkbox value={'1'}>高于进价</Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                    <Form.Item label='' name='eqCostPrice'>
                      <Checkbox.Group style={{ width: '120px' }}>
                        <Checkbox value={'1'}>等于进价</Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                  </Row>
                  <Row>
                    <Col
                      className={styles.formQueryLabel}
                    >
                    </Col>
                    <Form.Item label='' name='complexPrice'>
                      <Checkbox.Group>
                        <Checkbox value={'1'}>售价和支付标准在40元及以上且高于实际进价150% </Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                  </Row>
                  <Row>
                    <Col
                      className={styles.formQueryLabel}
                    >
                      医保限价：
                    </Col>
                    <Col>
                      <Form.Item label='' name='isLimitPrice'>
                        <Checkbox.Group>
                          <Checkbox value={'1'} style={{ width: '112px' }}>限价</Checkbox>
                          <Checkbox value={'0'}>不限价</Checkbox>
                        </Checkbox.Group>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      className={styles.formQueryLabel}
                    >
                      最近一次修改时间：
                    </Col>
                    <Col flex={1}>
                      <Form.Item label='' name='lastUpdateTime'>
                        <RangePicker
                          style={{ width: '416px' }}
                          format={DateTimeFormatSimpleOnlyOne}
                          showTime
                          allowClear
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row
                    style={{
                      height: '1px',
                      background: '#f0f0f0',
                      marginTop: '10px',
                    }}
                  ></Row>
                  <Space
                    style={{
                      display: 'flex',
                      justifyContent: 'end',
                      marginTop: '10px',
                    }}
                  >
                    <Button
                      size='middle'
                      type={'ghost'}
                      onClick={() => {
                        setOpen(false)
                      }}
                    >
                      取消
                    </Button>
                    <Button size='middle' type='primary' htmlType='submit'>
                      确定
                    </Button>
                  </Space>
                </Form>
              </>
            }
            title=''
            trigger='click'
            placement='bottom'
            onVisibleChange={(v) => {
              setOpen(v)
            }}
          >
            <Form.Item name='' initialValue={'筛选'} noStyle>
              <Button
                style={{
                  color: theme.tc2,
                  width: '78px',
                  textAlign: 'left',
                  // overflow: 'hidden',
                  // textOverflow: 'ellipsis',
                }}
                icon={
                  <FilterIconOutlined
                    style={{
                      width: '14px',
                      height: '14px',
                      position: 'relative',
                      top: 2,
                      left: -2,
                      color: '#666',
                    }}
                  />
                }
                onClick={() => {
                  setOpen(true)
                }}
              >
                筛选
              </Button>
            </Form.Item>
          </Popover>
          <Button onClick={refresh} type='primary' style={{ float: 'right' }} loading={props?.loading}>
            查询
          </Button>
          <FilterColumn
            filterColumn={props?.materialsCategory == '0' ? props?.filterColumn : props?.filterColumn?.filter((v: any) => v.field != 'genericName')}
            filterSelectList={props?.filterSelectList}
            // 筛选列变化时的数据
            onColumnVisibilityChange={(v: any) => {
              // 以 filterColumn 的顺序为基准，用 v 中的字段顺序重排，并保留 filterColumn 的 visible 状态
              const sortList = props?.filterColumn?.map((val: any) => {
                return {
                  ...val,
                  visible: v?.includes(val.field)
                }
              })
              props?.submitPageList && props?.submitPageList(sortList)
            }}
          />
        </Space>
      </Row>
    </Form>
  )
}

export interface YJTBQueryRef {
  reset: () => void
}
const YJTBQuerys = (
  props: {
    yjtbdkc?: any // 同步到库存
    spgl?: boolean // 是否是商品管理
    selectIds?: any
    loading?: any
    filterColumn?: any[]
    filterSelectList?: any[]
    submitPageList?: (v: any) => void
    onValueChange: (queries: commodityPageParams) => void
  }, ref: React.Ref<YJTBQueryRef>
) => {
  const [form] = Form.useForm()

  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [treeData, setTreeData] = useState<any>([])

  useImperativeHandle(ref, () => ({
    reset: () => {
      form.resetFields()
    },
  }))

  const getYPFL = () => {
    const data = Materiales.map((v) => {
      return {
        id: v,
        value: v.toString(),
        label: getMaterialsName(v),
        children: [],
      }
    })

    dispatch(
      getCommonCodeCompletionsAsync({
        category: CommonCodeCategory.Durg,
        keyword: '',
      },)
    )
      .then(unwrapResult)
      .then((res) => {
        const tree = data.map((v) => {
          if (v.id == 0) {
            return {
              ...v,
              children: res.records.map((el: any) => ({
                value: el.codeName,
                label: el.codeName,
              })),
            }
          } else if (v.id == 1) {
            return {
              ...v,
              children: [
                { value: '材料', label: '材料' },
                { value: '器械', label: '器械' },
                { value: '消耗品', label: '消耗品' },
                { value: '其他', label: '其他' },
              ],
            }
          } else if (v.id == 2) {
            return {
              ...v,
              children: [
                { value: '第一类医疗器械', label: '第一类医疗器械' },
                { value: '第二类医疗器械', label: '第二类医疗器械' },
                { value: '第三类医疗器械', label: '第三类医疗器械' },
              ],
            }
          } else if (v.id == 4) {
            return {
              ...v,
              children: [
                { value: '食品', label: '食品' },
                { value: '化妆品', label: '化妆品' },
                { value: '保健品', label: '保健品' },
                { value: '卫生消毒用品', label: '卫生消毒用品' },
                { value: '初级农产品', label: '初级农产品' },
                { value: '其他产品', label: '其他产品' },
              ],
            }
          } else {
            return v
          }
        })
        setTreeData(tree)
      })
  }

  useEffect(() => {
    if (props?.yjtbdkc == 1) {
      getYPFL()
    }
  }, [props?.yjtbdkc])

  const debouncedSubmit = useDebouncedCancel(300)

  const dropdownRender = useCascaderDropdownRender(
    treeData,
    () => normalizeMaterialsCategory(form.getFieldValue('materialsCategory')),
    (v) => form.setFieldsValue({ materialsCategory: v }),
    () => form.submit(),
  )

  return (
    <Form
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(values) => {
        const materialsCategoryList = values?.materialsCategory
        props.onValueChange({
          ...values,
          ...getMaterialsCategoryInfo(materialsCategoryList),
          materialsCategoryList: undefined,
          current: 1,
        })
      }}
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          {/* 商品管理allStr */}
          <Form.Item name={props?.spgl ? 'allStr' : 'name'} noStyle>
            <Input
              style={{ width: '200px' }}
              size='middle'
              placeholder='商品名称'
              allowClear
              prefix={<SearchOutlined />}
              onChange={(v: any) => {
                debouncedSubmit(() => form.submit())
              }}
            />
          </Form.Item>
          {/* 同步到库存 */}
          {props?.yjtbdkc == 1 ?
            <Form.Item name='materialsCategory' noStyle>
              <Cascader
                className={styles.materialsCategoryCascader}
                style={{ width: '200px' }}
                options={treeData}
                onChange={(v: any) => {
                  form.submit()
                }}
                multiple
                maxTagTextLength={12}
                changeOnSelect
                placeholder='商品类别'
                expandTrigger="hover"
                dropdownRender={dropdownRender}
              />
            </Form.Item>
            : <Form.Item
              name='billingCategory'
              noStyle
            >
              <Select
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                placeholder='开票项目'
                allowClear
                style={{ width: '120px' }}
                onChange={(e) => {
                  form.submit()
                }}
              >
                {InvoiceBillingCategories.map((v) => {
                  return (
                    <Option value={v} key={v}>
                      {BillingCategoryName(v)}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>}

          <Button onClick={() => { form.submit() }} type='primary' style={{ float: 'right' }} loading={props?.loading}>
            查询
          </Button>
          <FilterColumn
            filterColumn={props?.filterColumn}
            filterSelectList={props?.filterSelectList}
            // 筛选列变化时的数据
            onColumnVisibilityChange={(v: any) => {
              // 以 filterColumn 的顺序为基准，用 v 中的字段顺序重排，并保留 filterColumn 的 visible 状态
              const sortList = props?.filterColumn?.map((val: any) => {
                return {
                  ...val,
                  visible: v?.includes(val.field)
                }
              })
              props?.submitPageList && props?.submitPageList(sortList)
            }}
          />
        </Space>
        <Space>已选择{props?.selectIds?.length || 0}条</Space>
      </Row>
    </Form>
  )
}

export const YJTBQuery = forwardRef(YJTBQuerys)


export const JGBQMLDYQuery = (
  props: {
    selectIds?: any
    loading?: any
    filterColumn?: any[]
    filterSelectList?: any[]
    printJQ?: (v: any) => void
    deleteJQ?: (v: any) => void
    clearAllJQ?: () => void
    onValueChange: (queries: commodityPageParams) => void
  }
) => {
  const [form] = Form.useForm()
  
  const dispatch = useDispatch<RootDispatch>()

  const [inputValue, setInputValue] = useState('')
  const itemInputRef = useRef<any>(null)

  return (
    <Form
      form={form}
      name='control-hooks'
      autoComplete='off'
      onFinish={(values) => {
        props.onValueChange({
          ...values,
        })
      }}
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          <span>快速添加：</span>
          {/* 商品管理allStr */}
          <RecipeItemInput
            ref={itemInputRef}
            style={{ width: '320px' }}
            value={inputValue}
            onChange={setInputValue}
            isShowAddcatalog={false}
            placeholder={'搜索商品名称/扫码快速添加生成价格标签'}
            type={ItemCompletionType.Material}
            filters={false}
            useSpecifiedBatch={true}
            onSelect={(m: any) => {
              const catalogId = m?.materialsCatalogId || m?.id
              dispatch(savePriceTagCatalogAsync([Number(catalogId)]))
                .then(unwrapResult)
                .then(() => {
                  notification.success({ message: '添加成功' })
                  setInputValue('')
                  itemInputRef.current?.reset()
                  form.submit()
                })
            }}
            onPressEnter={(e: any) => {
              const value = e?.target?.value || ''
              // 追溯码：以 8 开头且长度 >= 20
              if (value?.startsWith('8') && value.length >= 20) {
                dispatch(
                  getRecipeItemCompletions({
                    type: ItemCompletionType.Material,
                    keyword: value,
                    current: 1,
                    size: 1,
                    receiptsType: 1,
                  })
                )
                  .then(unwrapResult)
                  .then(({ items }) => {
                    if (items?.length === 1) {
                      const m = items[0]
                      const catalogId = m?.materialsCatalogId || m?.id
                      if (catalogId) {
                        dispatch(savePriceTagCatalogAsync([Number(catalogId)]))
                          .then(unwrapResult)
                          .then(() => {
                            notification.success({ message: '已添加价签' })
                            setInputValue('')
                            itemInputRef.current?.reset()
                            form.submit()
                          })
                      }
                    } else if (items?.length > 1) {
                      notification.info({ message: '追溯码匹配到多个商品，请手动选择' })
                    } else {
                      notification.info({ message: '未匹配到商品' })
                    }
                  })
              }
            }}
            scene={"InputToReturn"}
            disablePatientPhone
          />
          {/* <FilterColumn
            filterColumn={props?.filterColumn}
            filterSelectList={props?.filterSelectList}
            // 筛选列变化时的数据
            onColumnVisibilityChange={(v: any) => {
              // 以 filterColumn 的顺序为基准，用 v 中的字段顺序重排，并保留 filterColumn 的 visible 状态
              const sortList = props?.filterColumn?.map((val: any) => {
                return {
                  ...val,
                  visible: v?.includes(val.field)
                }
              })
              props?.submitPageList && props?.submitPageList(sortList)
            }} 
          />*/}
        </Space>
        <Space>
          <Button type='primary' onClick={() => { props?.printJQ && props?.printJQ(props?.selectIds) }}>打印价签</Button>
          <Button type='primary' ghost danger onClick={() => { props?.deleteJQ && props?.deleteJQ(props?.selectIds) }}>删除勾选价签</Button>
          <Button type='primary' ghost danger onClick={() => { props?.clearAllJQ && props?.clearAllJQ() }}>清空所有价签</Button>
        </Space>
      </Row>
    </Form>
  )
}
